import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVehicleImageIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 16.9956V22.9956C30 25.4956 29.5 27.2456 28.38 28.3756L22 21.9956L29.73 14.2656C29.91 15.0556 30 15.9556 30 16.9956Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.73 14.2661L14.27 29.7261C11.26 29.0361 10 26.9561 10 22.9961V16.9961C10 11.9961 12 9.99609 17 9.99609H23C26.96 9.99609 29.04 11.2561 29.73 14.2661Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.3795 28.3761C27.2495 29.4961 25.4995 29.9961 22.9995 29.9961H16.9995C15.9595 29.9961 15.0595 29.9061 14.2695 29.7261L21.9995 21.9961L28.3795 28.3761Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 16.9961,
			r: 2,
			fill: "#7548F0"
		})
	]
});
export default SvgVehicleImageIcon;
